import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-detail-title-pj",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./detail-title-pj.component.html",
})
export class DetailTitlePjComponent {
  @Input() titleKey!: string;
  @Input() reference!: string;
}
